<template>
    <div class="filling-goods-div">
        <div style="padding-top: 10px; font-size: 16px">新建退货单</div>
        <div class="filling-goods-head-f">
            <div class="head-input-div-f" style="margin-bottom: 10px;">
                <div style="width: 20%; text-align: left">退货类型:</div>
                <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                    @click="TypePicker(0)" v-model="returnType" readonly="readonly" />
                <van-popup v-model="showPicker" position="bottom">
                    <van-picker :columns="returnList" @change="onChange"></van-picker>
                </van-popup>
            </div>
            <div class="head-input-div-f" style="margin-bottom: 10px;">
                <div style="width: 20%; text-align: left">退货方:</div>
                <input style="width: 50%;height: 25px; text-align: center;line-height: 25px;font-size: 16px;"
                    @click="TypePicker(1)" v-model="thf" readonly="readonly" />
                <van-popup v-model="SupplierPicker" position="bottom">
                    <van-picker :columns="SupplierList" @change="SSChange"></van-picker>
                </van-popup>
            </div>
            <div class="head-input-div-f">
                <div style="width: 20%; text-align: left">行数:</div>
                <input style="width: 80%;height: 25px;" readonly="readonly" :value="data.length" />
            </div>
            <!-- <div class="head-input-div-f">
          <div style="width: 20%; text-align: left">总数:</div>
          <input style="width: 80%" readonly="readonly" :value="allNum" />
        </div> -->
        </div>
        <div style="display: flex; justify-content: space-between; align-items: center">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="scanQRCode" @keyup.enter="add_reel()" ref="getIDInpot" v-model="add_data"
                    placeholder="扫描卷号条码" v-on:blur="hideMessage()" readonly style="height: 30px; width: 150px"
                    autocomplete="off" />
            </div>
            <span style="color: red" v-if="hostcs">测试服</span>
        </div>
        <div :style="style">
            <div class="goods-info-two-f" v-for="(i, index) in data" :key="index">
                <div style="width: 100%; text-align: right">
                    <van-icon name="cross" @click="deleteData(index)" style="margin: 5px 5px 5px 0" size="20px" />
                </div>
                <div class="sp-db-h" style="padding-top: 0px;">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">卷号:</div>
                        <div style="font-size:16px;">{{ i.reel }}</div>
                    </div>
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">门幅:</div>
                        <div style="font-size:16px;">{{ i.menfu }}</div>
                    </div>
                </div>
                <div class="sp-db-h">
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">货号:</div>
                        <div style="font-size:16px;">{{ i.number }}</div>
                    </div>
                    <div style="width: 50%; display: flex; align-items: center">
                        <div class="right-ret">数量:</div>
                        <div style="font-size:16px;">{{ i.store }} 米</div>
                    </div>
                </div>
                <div class="sp-db-h">
                    <div class="right-ret">供应商:</div>
                    <div style="font-size:16px;">{{ i.supplier }}</div>
                </div>
                <!-- <div class="info-order-h">
                    <div style="width: 50%; display: flex">
                        <div class="right-ret">卷号</div>
                        <div class="data-order">{{ i.reel }}</div>
                    </div>
                    <div style="width: 50%; display: flex">
                        <div class="right-ret">卷号描述</div>
                        <div class="data-order">{{ i.reel_detail }}</div>
                    </div>
                </div> -->
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <van-button type="info" class="bottom-button" @click="go_Submit()">提交</van-button>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
export default {
    name: "ReturnWarehouse",
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            parameterId: [],
            surplus: [],
            id: "",
            data: [],
            style: "",
            add_data: "",
            newData: {},
            add_data_all: {},
            newDataId: [],
            SupplierList: [],
            returnList: [
                '织布退货',
                '印染退货',
            ],
            returnType: '织布退货',
            thf: '',
            showPicker: false,
            SupplierPicker: false,
            ewmType: false,
            allNum: 0,
            GoodsType: false,
            revocationType: true,
            mather_id: "",
            getnumber: (i) => {
                if (i.indexOf("-") === -1) {
                    return i;
                } else {
                    return i.substr(0, i.indexOf("-"));
                }
            },
        };
    },
    computed: {
        ...mapState({
            number: (state) => state.number,
            FGid: (state) => state.FGid,
            type: (state) => state.type,
        }),
    },
    mounted() {
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.78 + "px;overflow:scroll;";
        this.focus();
        this.findS();
        setTimeout(() => {
            this.countAll();
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        ...mapMutations(["getNumber", "getFGid", "getType"]),
        create_fillingGoods(id) {
            Object.assign(this.$data, this.$options.data());
            this.$store.commit('getType', 'true')
            this.mather_id = id
        },
        fillingGoods(id) {
            this.mather_id = id
        },
        async findS() {  //获取供应商
            let Supplier = await this.get(this.APIOBJ.fingSupplier);
            this.SupplierList = Supplier.data.data
            console.log(Supplier)

        },
        handleRefresh() {
            this.$router.push("/fillingGoods?id=&FGid=&number=");
            window.location.reload();
        },
        getAdd() {
            //清楚数据
            this.add_data_all = {};
            this.data = [];
            this.allNum = 0;
            this.newDateId = [];
            this.$store.commit("getNumber", "");
            this.$store.commit("getType", "true");
            this.$store.commit("getFGid", "");
            this.mather_id = ''
        },
        countAll() {
            this.allNum = 0;
            for (let i of this.data) {
                this.allNum += parseFloat(i.goods_count);
            }
        },
        hideMessage() {
            this.ray = "已暂停，点击我继续扫码";
        },
        holdRay() {
            this.ray = "扫描中";
            this.focus();
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        TypePicker(index) {
            if (index == 1) {
                this.SupplierPicker = true;
            } else {
                this.showPicker = true;
            }
            // this.isDate = index;
        },
        onChange(picker, value, index) {
            this.returnType = value;
            this.showPicker = false;
        },
        SSChange(picker, value, index) {
            this.thf = value;
            this.SupplierPicker = false;
        },
        async add_reel() {
            if (!navigator.onLine) {
                // 没有网络的时候
                Toast("当前网络故障");
                this.add_data = "";
                return;
            }
            if (this.data.some(item => item.reel === this.add_data)) {
                this.add_data = "";
                Toast("该卷号已存在，请勿重复扫码");
                return;
            }
            let add_data = this.add_data;
            let datax = {
                reel: add_data,
            };
            document.getElementById("scanQRCode").disabled = true;
            let packing = await this.get(this.APIOBJ.getNormsware, datax);
            if (packing.data.length == 0) {
                this.add_data = "";
                Toast("该卷号不存在");
                document.getElementById("scanQRCode").disabled = false;
                document.getElementById("scanQRCode").focus();
                return;
            }
            if (this.thf != '' && this.thf != packing.data.supplier) {
                Toast("所选退货方和所扫卷号的供应商不一致");
                return;
            }
            var datay = {};
            datay.reel = packing.data.norms.reel;
            datay.menfu = packing.data.norms.menfu;
            datay.store = packing.data.norms.store;
            datay.number = packing.data.norms.number;
            datay.supplier = packing.data.supplier;
            this.thf = packing.data.supplier;
            document.getElementById("scanQRCode").disabled = false;
            document.getElementById("scanQRCode").focus();
            this.data = this.data.reverse();
            this.data.push(datay);
            this.data = this.data.reverse(); //装箱倒叙（倒序）代码，暂时注释，每次扫码都会对数据倒叙让使用者的体验不好
            this.add_data = "";
        },
        deleteData(index) {
            let name = this.data[index].reel
                ? this.data[index].reel
                : this.data[index].reel;
            Dialog.confirm({
                message: "确定要删除‘" + name + "’该卷号吗？",
            }).then(() => {
                Toast("已删除 " + name);
                this.data.splice(index, 1);
                this.countAll();
                if (this.id !== "") {
                    let id = this.id.replace(`${this.data[index].gck_number},`, "");
                    this.$route.query["id"] = id;
                    let query = { ...this.$route.query };
                    this.$router.replace({ query });
                }
            });
        },
        async go_Submit() {
            var username = JSON.parse(window.localStorage.getItem("userinfo"));
            if(this.GoodsType){
                return;
            }
            if (this.data.length == 0) {
                return;
            }
            const result = this.data.map(item => item.reel).join(',');
            let datax = {
                reel: result,
                back_supplier: this.thf,
                purback_type: this.returnType,
                user_name: username,
            };
            this.GoodsType = true;
            let res = await this.get(this.APIOBJ.purbackAdd, datax);
            console.log(res.status)
            if (res.data.status == 1) {
                Toast("退货提交成功");
                this.data = [];
                this.thf = '';
                this.holdRay();
                this.GoodsType = false;
            } else {
                Toast(res.data.msg);
                this.GoodsType = false;
            }
        },
        go_scan_url() {
            let url =
                "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
            window.location.href = url;
        },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
    },
};
</script>

<style lang="less">
.head-input-div-f {
    display: flex;
    width: 100%;
    align-items: center;
    position: relative;
}

.filling-goods-head-f {
    padding: 10px 0;
}

.filling-goods-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin-left: -10px;
}

.info-order {
    width: 100%;
    display: flex;
    background-color: white;
    margin: 5px 0;
    padding: 10px 0;
}

.goods-info-two-f {
    margin-top: 10px;
    background-color: #f2f2f2;
    padding-bottom: 10px;
}

.bottom-button {
    width: 25%;
}

.info-order-h {
    width: 100%;
    display: flex;
    padding-top: 5px;
}

.order-info-input {
    border-radius: 5px;
    border: 1px solid #444444;
    text-align: center;
    width: 4.5rem;
}

.info-order-data {
    width: 65%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.info-order-title {
    width: 35%;
}

.an-niu {
    border-radius: 5px;
    font-size: 12px;
}

.right-ret {
    // width: 1.6rem;
    font-size: 16px;
    margin: 0 15px;
    text-align: left;
}

.goods-info {
    margin-top: 10px;
    height: 300px;
    background-color: #f2f2f2;
}

.SbuttonDiv {
    position: fixed;
    bottom: 0;
    width: 100%;
    margin: 0 -10px;
}

.sp-db-h {
    width: 100%;
    padding-top: 10px;
    display: flex;
}

.more-class {
    border-top: 0.5px solid #444444;
}

.vatDia {
    color: #f2f2f2 !important;
    background-color: #f80b0b !important;
    font-size: 18px !important;
}

.vatDia .van-dialog__cancel .van-button__text {
    font-size: 18px;
    /* 根据需求调整字体大小 */
}

.vatDia .van-dialog__cancel {
    background-color: #f80b0b;
    color: #f2f2f2;
}

.vatDia .van-dialog__message {
    font-size: 18px;
}
</style>